import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'empty-layout',
    templateUrl: 'empty.layout.html',
})
export class EmptyLayout implements OnInit {

    constructor() { }

    ngOnInit() { }
}